module.exports = __webpack_public_path__ + "static/media/arrow-chevron-right.eeda2186.svg";